document.addEventListener("DOMContentLoaded", () => {

  if (!window.matchMedia("(max-width: 990px)").matches) return;

  const tabs = document.querySelectorAll(".comparison-tab");
  const cols = document.querySelectorAll(".comparison-col");

  const updateColumn = (index) => {

    cols.forEach((col, i) => {

      if (i === 0) {
        col.style.display = "grid";
        return;
      }

      col.style.display = (i === index) ? "grid" : "none";
    });

    tabs.forEach(t => t.classList.remove("active"));
    const activeTab = document.querySelector(`.comparison-tab[data-value="${index}"]`);
    if (activeTab) activeTab.classList.add("active");
  };

  // 👉 default
  updateColumn(1);

  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      updateColumn(parseInt(tab.dataset.value));
    });
  });

});
